import React from 'react'
import styled from 'styled-components'
import { ReactComponent as ChevronsNew } from 'icons/chevrons-up-down-16.svg'

const Chevrons = ({ className }: { className?: string }) => (
  <ChevronsNew className={className} height="12px" opacity="0.5" />
)

const DropdownChevrons = styled(Chevrons).attrs({ role: 'img' })``

export default DropdownChevrons
